import React from 'react'
import AddStartpageComToYourHomeScreen from '../add-startpage-com-to-your-home-screen'

const AddStartpageComToYourHomeScreenPl = () => {
    return <AddStartpageComToYourHomeScreen languageCode="pl" />
}

export default AddStartpageComToYourHomeScreenPl
